import React, { useRef, useEffect, useState } from 'react';
import { RichText } from 'prismic-reactjs'

const Accordeons = ({ items }) => {

	const [currentIndex, updateCurrentIndex] = useState(null);
	const itemsEls = useRef([]);

	// Set height depending on content height
	useEffect(() => {
		itemsEls.current.forEach(itemEl => {
			const closedHeight = itemEl.querySelector('.Accordeons__ItemHeader').getBoundingClientRect().height;
			const contentEl = itemEl.querySelector('.Accordeons__ItemContent');
			const contentElHeight = contentEl.getBoundingClientRect().height;
			const openHeightInPx = closedHeight + contentElHeight;
			const openHeightInVw = 100 * (openHeightInPx / window.innerWidth);
			itemEl.style.height = closedHeight + 'px';
			itemEl.setAttribute('data-closed-height', closedHeight);
			itemEl.setAttribute('data-open-height', openHeightInVw);
		})
	}, [])

	const handleOnKeyDown = e => {
		if (e.key === 'Enter') {
			onItemClick();
		}
	}

	const onItemClick = e => {
		const previousItem = itemsEls.current[currentIndex];
		if (previousItem) {
			previousItem.classList.remove('current');
			previousItem.style.height = previousItem.getAttribute('data-closed-height') + 'px';
		};

		const newIndex = e.target.closest('[data-accordeons-small-index]').getAttribute('data-accordeons-small-index');
		const newItem = itemsEls.current[newIndex];

		if (currentIndex === newIndex) {
			updateCurrentIndex(null);
		} else {
			updateCurrentIndex(newIndex);
			newItem.classList.add('current');
			newItem.style = `height: ${newItem.getAttribute('data-open-height')}vw;`;
		}
	}


	return (
		<section className="Accordeons">
			{items.map((item, index) => (
				<div
					className="Accordeons__Item"
					data-accordeons-small-index={index}
					onKeyDown={handleOnKeyDown}
					role="button"
					tabIndex={0}
					ref={ref => itemsEls.current[index] = ref}
					key={`accordeons-small-item-${index}`}
				>
					<div className="Accordeons__ItemHeader" onClick={onItemClick}>
						<h4 className="Accordeons__ItemHeaderTitle">
							{item.question.text}
						</h4>
						<div className="Accordeons__ItemHeaderIcon"></div>
					</div>
					<div className="Accordeons__ItemContent">
						<RichText render={item.answer.richText} />
					</div>
				</div>
			))}
		</section>
	)
}

export default Accordeons;